'use client';
import dynamic from "next/dynamic";
import { useRef, useEffect } from "react";

// Dynamically load the actual client slider (not SSR)
const ClientImageSlider = dynamic(() => import('./ClientImageSlider'), { ssr: false });

export default function SliderHydrator({ slides }) {
  const sliderRef = useRef(null);

  // Fade in after hydration for smooth transition (optional)
  useEffect(() => {
    if (sliderRef.current) {
      // Start faded out, fade in over 300ms
      sliderRef.current.style.opacity = 1;
    }
  }, []);

  return (
    <div
      ref={sliderRef}
      className="absolute inset-0 transition-opacity duration-500"
      style={{ opacity: 0, zIndex: 2, pointerEvents: "auto" }}
      aria-hidden={false}
    >
      <ClientImageSlider slides={slides} />
    </div>
  );
}
